const Config  = {
    // BACKEND_URL : "http://localhost:5000/api",
    EMAILJS_SERVICE_ID: "service_hq3a9xq",
    EMAILJS_TEMPLATE_ID: "template_lz35qyd",
    EMAILJS_USER_ID: "KwB2H8Bm5-5KomgoC",
    BACKEND_URL : "https://jb-backend-2k8r.onrender.com/api"
}

export default Config;